import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    number: "01",
    title: "Call or Text Us",
    description: "Reach out to Stu directly at (251) 243-1403. We just need basic details like the state where your property is located to start our research."
  },
  {
    number: "02",
    title: "Receive a Fair Cash Offer",
    description: "We'll review recent sales data and county records to determine a fair price. We'll present you with a no-obligation cash offer quickly."
  },
  {
    number: "03",
    title: "Get Paid",
    description: "If you accept, we send the agreement to a reputable local title company. They handle the paperwork, and you receive your funds."
  }
];

export default function Process() {
  return (
    <section id="how-it-works" className="py-24 bg-stone-900 text-white relative overflow-hidden">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-brand-900/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="mb-16">
          <h2 className="text-brand-400 font-semibold tracking-wide uppercase text-sm mb-2">The Process</h2>
          <h3 className="text-3xl md:text-4xl font-serif font-bold mb-4">Sell in 3 Simple Steps</h3>
          <p className="text-stone-400 max-w-2xl text-lg">We've removed the friction from selling real estate. Our process is transparent, straightforward, and entirely hands-off for you.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 relative">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-[45px] left-[10%] right-[10%] h-0.5 bg-stone-700"></div>
          
          {steps.map((step, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              className="relative"
            >
              <div className="w-24 h-24 bg-stone-800 border-4 border-stone-900 rounded-full flex items-center justify-center text-3xl font-bold font-serif text-brand-400 mb-6 relative z-10 shadow-xl">
                {step.number}
              </div>
              <h4 className="text-2xl font-bold mb-4">{step.title}</h4>
              <p className="text-stone-400 leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}